import { useTranslation } from 'react-i18next'

import { IQuestion } from 'cat-shared/utils'
import { AppParagraph } from 'client/ui-building-blocks'
import { humanizeFromToNow, formatTimestamp } from 'client/services'
import { type TGetQuestionsData } from 'client/api/useGetQuestions/useGetQuestions'

type Props = {
  question: IQuestion
  questionsData?: TGetQuestionsData
}

export const QuestionMetaText = ({ question, questionsData }: Props) => {
  const { t, i18n } = useTranslation()

  const submittedTimes =
    question?.submittedTimes ||
    questionsData?.data.find(q => q._id.toString() === question?._id.toString())
      ?.submittedTimes

  return (
    <>
      <AppParagraph
        text={
          t('question.info.creationTimePassed', {
            timePassed: humanizeFromToNow(question?.createdAt, i18n.language),
          }) +
          ' ' +
          t('question.info.creationDateTime', {
            dateTime: formatTimestamp(question?.createdAt, i18n.language),
          })
        }
        size="small"
        color="secondary"
      />
      <AppParagraph
        text={
          submittedTimes !== undefined
            ? t('question.info.submittedTimes', { count: submittedTimes })
            : '...'
        }
        size="small"
        color="secondary"
      />
    </>
  )
}
